import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-[12px] font-medium uppercase tracking-[-0.01em] transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground shadow",
        secondary: "border-transparent bg-secondary text-secondary-foreground",
        destructive: "border-transparent bg-destructive text-destructive-foreground shadow",
        outline: "text-foreground",
        neutral: "border-transparent bg-badge-neutral text-badge-neutral-foreground",
        count: "h-[22px] border-transparent bg-badge-count leading-3 tracking-normal text-badge-count-foreground",
        active: "border-transparent bg-status-active text-white",
        pending: "border-transparent bg-status-pending text-white",
        suspended: "border-transparent bg-status-suspended text-white",
        expired: "border-transparent bg-status-expired text-white",
        cancelled: "border-transparent bg-status-cancelled text-white",
        alert: "border-transparent bg-status-alert text-white",
        complete: "border-transparent bg-status-complete text-white",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
